<div class="flex justify-center content-center w-full h-screen">
  <div class="flex content-center w-full">
    <validation-email></validation-email>
  </div>
</div>